<template>
    <div class="article-list-section">
        <van-row v-if="dataItem" class="article-list-section-box" @click.prevent="go_article_detail(dataItem)">
            <van-col class="article-list-section-left">
                <van-image
                    v-if="dataItem.cover_img"
                    fit="cover"
                    class="article-list-content-imgs"
                    :src="dataItem.cover_img"
                    width="100%"
                    height="73"
                />
                <div class="article-list-section-left-zl" v-if="dataItem.type === 2">
                    <img src="/static/v4/assembly/icon_list_tag_column.svg" alt="" />
                </div>
            </van-col>

            <van-col class="article-list-content">
                <div class="article-list-title">
                    {{ dataItem.title | omitTitle }}
                </div>
                <div class="article-list-content-detail">
                    <div v-if="dataItem.type === 2">共{{ dataItem.current_count }}节 {{ dataItem.total_count }}节</div>
                    <div v-else>
                        <span>{{ dataItem.created_at }}</span>
                        <span>{{ dataItem.view_count }}人阅读</span>
                    </div>
                </div>
            </van-col>
        </van-row>
    </div>
</template>

<script>
// import Interface from '@/util/interface'

export default {
    name: 'Article',
    props: {
        dataItem: {
            type: Object,
            required: true
        },
        contentItem: {
            type: Object
        },
        wapperFn: {
            type: Boolean,
            default: false
        }
    },

    filters: {
        omitTitle(value) {
            if (value.length > 18) {
                return value.slice(0, 18) + '...'
            } else {
                return value
            }
        }
    },
    methods: {
        go_article_detail(row) {
            if (!this.wapperFn) {
                console.log('内部触发')
            } else {
                this.$emit('goDetail', row)
            }
        },
        handleStatus(row) {
            this.$emit('hadnleStatus', row)
        }
        // getViewCount(row) {
        //     Interface.getData(
        //         "get",
        //         `/course-phase/api/recommend_v2/${row.id}/view`
        //     );
        // }
    }
}
</script>

<style lang="scss" scoped>
@import '@/components/variable.scss';

.article-list-section {
    background-color: #ffffff;
    border-radius: 10px 10px 0px 0px;
    border-bottom: 1px solid #f2f2f2;
    padding-bottom: 20px;
    padding-top: 16px;
    position: relative;

    .article-list-title {
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 500;
        text-align: justify;
        display: -webkit-box;
        .light {
            color: #0fb7ad;
        }
    }

    .article-list-content {
        text-align: left;
        position: relative;
        height: 80px;

        &-desc {
            margin-top: 9px;
            font-size: 14px;
            color: $desc-color;
            text-align: justify;
            display: -webkit-box;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 2;
            word-break: break-all;
            overflow: hidden;
        }

        &-detail {
            margin-top: 10px;
            width: 100%;
            font-family: PingFangSC-Regular;
            font-size: 12px;
            color: #9d9d9d;
            letter-spacing: 0;
            .float-right {
                float: right;
                padding-right: $font16;
            }
            div {
                display: inline-block;
            }
        }

        &-img {
            width: 112px;
            height: 72px;
            border-radius: 6px;
            >>> .van-image__img {
                border-radius: 6px;
            }
            img {
                width: 112px;
                border-radius: 6px;
            }
        }
    }

    .article-list-section-left-zl {
        position: absolute;
        left: 0px;
        top: 0px;
        border-radius: 3px;
        &.active {
            background-image: linear-gradient(135deg, #ffa3af 0%, #ff555e 100%);
            border-radius: 6px 3px 3px 3px;
        }
    }

    .article-list-section-left {
        border-radius: 6px;
    }
    .article-list-content {
        width: 193px;
        height: 68px;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
    }
    .article-list-content-imgs {
        margin-right: 10px;
        border-radius: 6px;
        /deep/ .van-image__img {
            width: 130px;
            height: 72px;
            border-radius: 6px;
        }
    }

    .article-list-section-left-top {
        position: absolute;
        top: 4px;
        left: 4px;
        width: 18px;
        height: 18px;
        border-radius: 3px;
        img {
            width: 18px;
            height: 18px;
            border-radius: 3px;
        }
    }
    .article-list-section-box:after {
        padding-top: 0;
        margin-bottom: 0;
    }
}
</style>



// WEBPACK FOOTER //
// src/views/case/column/article.vue